export const orderBy = (items, key) => {
    return items.concat().sort((a, b) => {
        return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
    });
};
